@if (state && hasMultipleTenants()) {
  <div class="tenant-switcher">
    <button
      type="button"
      class="tenant-trigger"
      [attr.aria-expanded]="dropdownOpen()"
      [attr.aria-label]="'Condominio actual: ' + (currentTenant()?.name ?? 'Sin seleccionar') + '. Cambiar condominio'"
      aria-haspopup="menu"
      (click)="toggleDropdown()"
      (keyup.enter)="toggleDropdown()">
      <i class="pi pi-sitemap" aria-hidden="true"></i>
      <span class="tenant-trigger-name">{{ currentTenant()?.name ?? 'Seleccionar condominio' }}</span>
      <i class="pi pi-chevron-down tenant-trigger-chevron" [class.rotated]="dropdownOpen()" aria-hidden="true"></i>
    </button>

    @if (dropdownOpen()) {
      <div class="tenant-dropdown animate-scalein" role="menu" aria-label="Cambiar de condominio">
        @for (tenant of state.tenants; track tenant.id) {
          @if (tenant.id !== state.currentTenantId) {
            <button
              class="tenant-option"
              role="menuitem"
              [attr.aria-selected]="false"
              type="button"
              (click)="selectTenant(tenant)"
              (keyup.enter)="selectTenant(tenant)">
              {{ tenant.name }}
            </button>
          }
        }
      </div>
    }
  </div>
} @else if (state && currentTenant()) {
  <div class="tenant-switcher">
    <div class="tenant-trigger !cursor-default">
      <i class="pi pi-sitemap" aria-hidden="true"></i>
      <span class="tenant-trigger-name">{{ currentTenant()?.name }}</span>
    </div>
  </div>
}

@if (transitionTenant()) {
  <output class="tenant-overlay" aria-live="assertive" aria-atomic="true">
    <div class="tenant-overlay-content">
      <app-convivia-logo size="72px" />

      @if (!hasError()) {
        <div class="tenant-overlay-body">
          <div class="tenant-overlay-spinner" aria-hidden="true"></div>
          <p class="tenant-overlay-label">
            Cambiando de condominio a <strong>{{ transitionTenant()?.name }}</strong>
          </p>
        </div>
      } @else {
        <div class="tenant-overlay-body">
          <i class="pi pi-exclamation-circle tenant-overlay-error-icon" aria-hidden="true"></i>
          <p class="tenant-overlay-label">
            No fue posible cambiar al condominio <strong>{{ transitionTenant()?.name }}</strong>
          </p>
          <button
            type="button"
            class="tenant-overlay-cancel"
            (click)="cancelTransition()"
            (keyup.enter)="cancelTransition()">
            Cancelar
          </button>
        </div>
      }
    </div>
  </output>
}
